export const nl2p = (str: string) => {
    return str.split("\n").map(st => <p key={crypto.randomUUID()}>{st}</p>);
}

export const setCanonical = (url?: string) => {
    let can = document.querySelector("link[rel=canonical]");
    if(!can) {
        can = document.createElement("link");
        can.setAttribute("rel", "canonical");
        document.head.appendChild(can);
    }
    can.setAttribute("href", url || document.location.href);
}

export const isMobileApp = () => {
    try {
        return Boolean(window.localStorage.getItem("isMobileApp"));
    } catch(e) {}
    return false;
}